const CompanyPermissions = {
  edit: 'company:edit',
  create: 'company:create',
  delete: 'company:delete',
  view: 'company:view',
}

export default CompanyPermissions
